// extracted by mini-css-extract-plugin
export default {"header":"main_header__rK4gv","sidebar1":"main_sidebar1__JusfJ","sidebar2":"main_sidebar2__emhKW","content":"main_content__Faoh2"};